import { Backdrop } from "@mui/material";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { useTranslation } from "react-i18next";
import MovingBorderButton from "components/MovingBorderButton";
import { HourglassEmpty } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { format, parseISO } from "date-fns";

const AssessmentTutorialModal = (props: {
  open: boolean;
  handleClose;
  reservation?;
  isInstancePageReady?;
  lab?;
  showCooking?: boolean;
  showBooked?: boolean;
  showReady?: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { open, handleClose, reservation, showCooking, showBooked, showReady } = props;

  const goToInstancePage = () => {
    navigate(`/assignment/${reservation.instance_id}`);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-schedule-lab"
      className="flex flex-col justify-center items-center text-center"
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(255,255,255,0.2)",
            backdropFilter: "blur(5px)",
          },
        },
      }}
    >
      <div className="md:max-w-auto custom-scrollbar container absolute left-1/2 top-1/2 flex h-auto max-h-[calc(100%-40px)] w-[583px] max-w-[calc(100%-20px)] -translate-x-1/2 -translate-y-1/2 flex-col justify-center overflow-y-scroll rounded-[13px] bg-blue px-[10px] pb-[36px] pt-[54px] shadow-[0px_7.89927px_32.7255px_rgba(100,100,111,0.2)] md:px-[50px] md:pb-[42px] md:pt-[54px]">
        {/* <video
          className="mx-auto h-[283px] max-w-[470px]"
          autoPlay
          loop
          poster={require("assets/paused-video.png")}
          src={require("assets/paused-video.png")}
        /> */}
        <h1 className="custom-text-poppins-600-20px mb-[22px] mt-[36px] text-white">
          Everything you need to know about your Lab space before you get
          started
        </h1>
        <h5 className="custom-text-poppins-400-17px px-[20px] text-white">
          <ul className="list-disc list-inside text-left">
            <li>Quick tour to show you around.</li>
            <li>Few tips to make things easier. </li>
            <li>Reminders to make sure everything is smooth.</li>
          </ul>
        </h5>
        <div className="assignment_scheduling_btn_group !mt-[37px]">
          {showReady && (
            <div className="reservation-group">
              <Button
                onClick={() => goToInstancePage()}
                className="!custom-text-poppins-600-14_4px !mx-auto !h-[47px] !w-[138px] !rounded-[6.5px] !bg-white !normal-case !text-blue"
              >
                {t("get-started")}
              </Button>
            </div>
          )}
          {reservation && (
            <>
              {showCooking && (
                <MovingBorderButton
                  borderRadius="6.5px"
                  containerClassName="reservation-group h-[50px] w-full max-w-[200px]"
                  className="btn reservation !h-[47px] !w-full !max-w-[564px] !border-none bg-white text-black"
                  duration={2000}
                >
                  <h4 className="!custom-text-poppins-600-14_4px !text-blue">
                    <HourglassEmpty className="animate-spin" /> {t("its-cooking")}
                  </h4>
                </MovingBorderButton>
              )}
              {showBooked && (
                <div className="reservation-group">
                  <Button
                    disableElevation
                    disableFocusRipple
                    disableRipple
                    disableTouchRipple
                    className="btn reservation !h-[50px] max-w-[460px] !rounded-[6.5px] !shadow-none"
                  >
                    <h4 className="!custom-text-poppins-600-14_4px normal-case">
                      ⚡{" "}
                      {format(
                        parseISO(new Date().toISOString()),
                        `'${t("booked-for-the")}' do LLLL uuuu '${t("at")}' hh:mm a`,
                      )}{" "}
                      ⚡
                    </h4>
                  </Button>
                  <h5 className="!text-[12px] !text-white">
                    {t("see-you-soon")}
                  </h5>
                </div>
              )}
            </>
          )}
          {!showReady && !reservation && (
            <h4 className="assignment_scheduling-errors cursor-pointer rounded-[6.5px] bg-white p-3 text-blue">
              {t("error-please-contact-support")}
            </h4>
          )}
        </div>
      </div>
    </Modal >
  );
};

export default AssessmentTutorialModal;
